export default "__VITE_ASSET__1912d478__"